if (typeof Billing == 'undefined') Billing = {};
Billing.Router = Core.SubRouter.extend({

    routes: {
        '': 'customer',
        'overview': 'overview',
        'step1': 'step1',
        'step2': 'step2',
        'step3': 'step3',
        'invoice/:id': 'invoice',
        'customer/:customerUuid/invoice/:invoiceId': 'customerInvoice',
        'admin': 'admin',
        'admin/customer/:id': 'adminCustomer',
        'admin/invoicing': 'adminInvoicing',
    },

    customer: function() {
        app.setMainView(new Billing.CustomerView(), 'settings');
    },

    overview: function() {
        if (!app.view || !app.view.goStep) this.customer();
        app.view.goStep('overview');
    },

    step1: function() {
        if (!app.view || !app.view.goStep) this.customer();
        app.view.goStep(1);
    },

    step2: function() {
        if (!app.view || !app.view.goStep) this.customer();
        app.view.goStep(2);
    },

    step3: function() {
        if (!app.view || !app.view.goStep) this.customer();
        app.view.goStep(3);
    },

    invoice: function(id) {
        app.setMainView(new Billing.InvoiceView({model: new Billing.Invoice({id: id, path: id})}), 'admin');
    },

    customerInvoice: function(customerUuid, invoiceId) {
        app.setMainView(new Billing.InvoiceView({
            model: new Billing.Invoice({
                path: 'customer/' + customerUuid + '/invoice/' + invoiceId,
            })
        }));
    },

    admin: function() {
        app.setMainView(new Billing.AdminView(), 'admin');
    },

    adminCustomer: function(id) {
        app.setMainView(new Billing.AdminCustomerView({model: new Billing.Customer({uuid: id}), showingDetails: true}), 'admin');
    },

    adminInvoicing: function() {
        app.setMainView(new Billing.InvoicingView(), 'admin');
    },

});
